import { render } from "./MyPageEmailSettingsError.vue?vue&type=template&id=0de09f71&scoped=true&ts=true"
import script from "./MyPageEmailSettingsError.vue?vue&type=script&lang=ts"
export * from "./MyPageEmailSettingsError.vue?vue&type=script&lang=ts"

import "./MyPageEmailSettingsError.vue?vue&type=style&index=0&id=0de09f71&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0de09f71"]])

export default __exports__